import React from 'react';
import {useSelector} from 'react-redux';
import {Navigate, useLocation} from 'react-router-dom';
import {makeStyles} from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
import {usePermissions} from 'auth/permissions';

const useStyles = makeStyles(theme => ({
    logo: {
        width: '300px',
        marginTop: '80px',
        marginBottom: '80px'
    },
    flex: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
    }
}));

const PrivateRoute = ({requiredPermission, children, ...rest}) => {

    const location = useLocation();
    const classes = useStyles();
    const authPending = useSelector(state => state.auth.pending);
    const authorized = useSelector(state => state.auth.authorized);
    const hasPermission = usePermissions();

    if (requiredPermission && !hasPermission(requiredPermission)) {
        return <Navigate to="/home" replace/>;
    }

    return authorized ? (
        children
    ) : authPending ? (
        <div>
            <div className={classes.flex}>
                <img alt="Logo" className={classes.logo}
                     src="https://cdn.homecareconnect.com/images/paradigm_orange_logo.svg"/>
            </div>
            <div className={classes.flex}>
                <CircularProgress/>
            </div>
        </div>
    ) : (
        <Navigate
            to="/auth/login"
            replace
            state={{from: location}}
        />
    );
};
export {PrivateRoute};